module.exports = __webpack_public_path__ + "img/logo-login-page.2e77d77b.png";